import { Entity } from "../helpers/Entity"

export type PaymentTypeDtoAttributes = {
    accountId: string
    name: string
    icon: string
    description: string
    status: string
}

export type PaymentTypeDto = {
    id: string
    type: string
    attributes: PaymentTypeDtoAttributes
}

export default class PaymentType implements Entity {
    private dto: PaymentTypeDto
    constructor(dto: PaymentTypeDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "payment-types"
    }

    getId(): string {
        return this.dto.id
    }

    getName(): string {
        return this.dto.attributes.name
    }

    getStatus(): string {
        return this.dto.attributes.status
    }

}


// WEBPACK FOOTER //
// ./src/state/payment-type/PaymentType.ts